/** Default injection keys (Vue `provide`, Nuxt, string tokens) */
export const TELEMETRY_CLIENT_KEY = "telemetry.client" as const;
export const TELEMETRY_SERVER_KEY = "telemetry.server" as const;

/** Symbol tokens for React context / generic containers */
export const TELEMETRY_CLIENT_TOKEN = Symbol.for("@komerce/telemetry.client");
export const TELEMETRY_SERVER_TOKEN = Symbol.for("@komerce/telemetry.server");

export type TelemetryTokenKey =
  | typeof TELEMETRY_CLIENT_KEY
  | typeof TELEMETRY_SERVER_KEY
  | typeof TELEMETRY_CLIENT_TOKEN
  | typeof TELEMETRY_SERVER_TOKEN;
